import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { FormActivityInputViewComponent } from '../../form-activity-editor/form-activity-input/form-activity-input-view/form-activity-input-view.component';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SignOffActivity } from 'src/app/models/activities/sign-off-activity';

@Component({
  selector: 'wm-sign-off-activity-input',
  templateUrl: './sign-off-activity-input.component.html',
  styleUrls: ['./sign-off-activity-input.component.css'],
  standalone: false
})
export class SignOffActivityInputComponent extends ActivityView implements OnInit {
  @ViewChild('formActivityInputView', { static: false })
    formActivityInputViewCtl: FormActivityInputViewComponent;

  activity: SignOffActivity;
  loading = false;

  constructor(
    private _ref: ChangeDetectorRef,
    private toastr: ToastrService
  ) {
    super();
  }

  ngOnInit() {
    // Form controls are automatically created by FormActivity
    // Based on the data entities defined in SignOffActivity
    // SIGN_OFF_NAME, SIGN_OFF_DECISION, SIGN_OFF_COMMENTS, SIGN_OFF_DECISION_DATE
  }
}

